import { useEffect } from "react";

const useBlockDevTools = () => {
  useEffect(() => {
    const blockDevTools = (e) => {
      // F12
      if (e.key === "F12") {
        e.preventDefault();
        e.stopPropagation();
      }

      // Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U, Ctrl+S
      if (
        (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key.toUpperCase())) ||
        (e.ctrlKey && ["U", "S"].includes(e.key.toUpperCase()))
      ) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    const blockContextMenu = (e) => {
      e.preventDefault();
    };

    window.addEventListener("keydown", blockDevTools);
    window.addEventListener("contextmenu", blockContextMenu);

    const trapConsole = () => {
      const element = new Image();
      Object.defineProperty(element, "id", {
        get: function () {
          alert("Warning: Do not paste anything here. It may compromise your security.");
          // You could redirect, log, or disable app here
        },
      });
      console.log("%cStop!", "font-size: 40px; color: red;");
      console.log("%cThis browser feature is for developers. Do not paste any code here!", "font-size: 16px;");
      // console.log(element);
    };

    trapConsole();


    return () => {
      window.removeEventListener("keydown", blockDevTools);
      window.removeEventListener("contextmenu", blockContextMenu);
    };
  }, []);
};

export default useBlockDevTools;
